import { OnInit, Component, transition, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';

import { NgbModal, NgbActiveModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';

import { FADE_IN_OUT_ANIMATION } from '@shared/animations';
import { ParseObject, Language, FileRef, Network, MenuNode, Page } from '@shared/data';
import { CrudService, LanguageService, PageService } from '@shared/services';
import { MenuQuery, PageQuery } from '@shared/queries';

import { InputImageEvent } from '@shared/modules/input-image';
import { LoadingService } from '@shared/modules/loading';
import { AlertService } from '@shared/modules/alert';

@Component({
  moduleId: 'module.id',
  selector: 'edit-menu',
  styles: [require('./edit-menu.component.scss')],
  template: require('./edit-menu.component.html'),
  animations: [FADE_IN_OUT_ANIMATION]
})
export class EditMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  public parent: MenuNode;

  @Input()
  public node: MenuNode;

  public languages: Observable<Language[]>;
  public pages: Observable<Page[]>;
  public lang: string;

  public error: Parse.Error;
  public isSaving: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    public languageService: LanguageService) {

    this.languages = this.languageService.find().publishReplay(1).refCount();
    this.lang = this.languageService.defaultLang;
  }

  public ngOnInit(): void {
    this.pages = new PageQuery().rx().find();
  }

  public ngAfterViewInit(): void {

  }

  public ngOnDestroy(): void {

  }

  public get pageId(): string {
    return this.node.page ? this.node.page.id : '';
  }

  public set pageId(id: string) {
    this.node.page = id != '' ? Page.createWithoutData(id) : undefined;
  }

  // ===============================================================================================
  // Public Methods
  // ===============================================================================================

  public set(key: string, value: string, lang: string) {
    this.node[key + '_' + lang] = value;
  }

  public get(key: string, lang: string) {
    return this.node[key + '_' + lang];
  }

  public setTitle(title: string, lang: string) {
    return this.set(MenuNode.TITLE_KEY, title, lang);
  }

  public getTitle(lang: string) {
    return this.get(MenuNode.TITLE_KEY, lang);
  }

  public get isValid() {
    return this.node.name;
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onSave(): void {
    this.activeModal.close(this.node);
  }

  public onTabChange(evt: NgbTabChangeEvent) {
    this.lang = evt.nextId;
  }

  public onCancel() {
    this.activeModal.dismiss();
  }

  public onDismiss() {
    this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+menu/edit-menu/edit-menu.component.ts